import { z } from "zod";

export const CriarProdutoSchema = z.object({
    nome: z.string()
        .nonempty("O nome do produto é obrigatório.")
        .min(3, "O nome do produto deve ter no mínimo 3 caracteres")
        .max(120, "O nome do produto deve ter no máximo 120 caracteres"),

    cod_consulta: z.string()
        .nonempty("O código de consulta é obrigatório.")
        .refine((val) => !isNaN(Number(val)) && Number(val) > 0, {
            message: "O código de consulta deve ser um número válido maior que 0."
        }),

    valor: z.string()
        .nonempty("O valor do produto é obrigatório.")
        .refine((v) => v !== "R$ 0:00", {
            message: "O valor do produto não pode ser vazio ou zero.",
        }),

    status: z.enum(["S", "N"], {
        errorMap: () => ({ message: "O status deve ser 'S' ou 'N'" })
    })
});